module.exports = __webpack_public_path__ + "static/media/mobile-plan-android-mweb.a12f862a.webp";